import SoftTypography from 'components/SoftTypography'
import styled from 'styled-components'
import { useEffect, useState, useContext } from 'react'
import { useFormDebounce } from 'hooks/useFormDebounce'
import { usePlaidLink } from 'react-plaid-link'
import { useIntake } from 'hooks/useIntakeContext'
import { PlaidLogo } from 'components/PlaidLogo'
import { QuilttLogo } from 'components/QuilttLogo'
import RefreshIcon from '@mui/icons-material/Refresh'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
// import { apiClient } from 'utils/api/apiClient'
import { useApi } from 'hooks/useApi'
import { QuilttButton } from '@quiltt/react'
import { QuilttContainer } from '@quiltt/react'
import { QuilttProvider } from '@quiltt/react'
import { toast } from 'react-toastify'
import { Box, Button } from '@mui/material'
import { Link } from '@mui/icons-material'

const StyledDiv = styled.div`
  button {
    border: none;
    cursor: pointer;
    padding: 6px 18px;
    font-size: 16px;
    line-height: 1.5;
    color: #5d6d8e;
    background-color: transparent;
    font-weight: 500;
    text-transform: capitalize;
    svg {
      font-size: 1.5rem !important;
      margin-right: 4px;
      margin-bottom: -6px;
    }
  }
  button:hover, button:focus, button:active, button:focus:not(:hover): {
    transform: 'none';
    boxshadow: 'none';
  }
`

const StyledSpan = styled.span`
  width: auto;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #adc5e3;
  color: #5d6d8e;
  background-color: #e4f0ff;
  &:hover {
    background-color: #cdd8e5;
    cursor: pointer;
  }
`

export const ImportFromQuiltt = ({ handleUpdateAccounts, height = '15px' }) => {
  const [linkToken, setLinkToken] = useState()
  const { intakeState, updateIntakeStateAtKey } = useIntake()
  const { updateIntakeStateAndSubmit } = useFormDebounce()
  const { apiRequest } = useApi()

  const [assets, setAssets] = useState([])
  const [liabilities, setLiabilities] = useState([])

  const updateQuiltt = async (quilttUserId) => {
    // console.log(quilttUserId)
    try {
      const { data } = await apiRequest('/api/quiltt/quilttSession', {
        method: 'POST',
        body: JSON.stringify({ quilttUserId: quilttUserId }),
      })
      handleUpdateAccounts && handleUpdateAccounts()
      // console.log(data)
    } catch (e) {
      console.error(e)
    }
  }

  const updateUserWithQuilttId = (quilttUserId) => {
    updateIntakeStateAndSubmit(() => {
      const newState = updateIntakeStateAtKey({ quilttUserId: quilttUserId })
      return newState
    })()
  }

  const refreshQuiltt = () => {
    // console.log(typeof intakeState?.quilttUserId)
    updateQuiltt(intakeState?.quilttUserId)
    toast.success(
      'Fetching updated account balances with Quiltt! They will appear in your balance sheet momentarily',
      {
        position: 'top-center',
        autoClose: 8000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
      }
    )
  }

  const handleLoad = (metadata) =>
    console.log(`Connector ${metadata.connectorId} loaded!`)
  const handleExitSuccess = (metadata) => {
    // console.log(metadata.profileId)
    // console.log(typeof metadata.profileId)
    setTimeout(() => {
      updateQuiltt(metadata.profileId)
    }, 5000)
    // console.log(intakeState?.quilttUserId)
    if (
      !intakeState?.quilttUserId ||
      metadata.profileId !== intakeState?.quilttUserId
    ) {
      updateUserWithQuilttId(metadata.profileId)
    }

    toast.success(
      'You have successfully added your accounts with Quiltt! They will appear in your balance sheet momentarily',
      {
        position: 'top-center',
        autoClose: 8000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
      }
    )
  }

  useEffect(() => {
    // Fetch quiltt accounts if there is an existing quiltt UserId
    if (intakeState?.quilttUserId) {
      updateQuiltt(intakeState?.quilttUserId)
      console.log('Quiltt Updated')
    }

    let loaded = false
    if (loaded) return

    const getAccounts = async () => {
      const response = await apiRequest('/api/assets')
      const { items } = await response.json()
      const foundAssets = items?.filter(({ type }) => type === 'asset') || []
      setAssets(foundAssets)
      const foundLiabilities =
        items?.filter(({ type }) => type === 'liability') || []
      setLiabilities(foundLiabilities)
      loaded = true
    }

    getAccounts()
  }, [apiRequest])

  return (
    <>
      {/* <StyledDiv onClick={generateToken}>
        <StyledSpan>
          <SoftTypography textAlign="center" color="dark" variant="body2">
            Link Accounts with
          </SoftTypography>
          &nbsp;
          <QuilttLogo />
        </StyledSpan>
      </StyledDiv> */}
      <StyledDiv>
        <StyledSpan>
          <QuilttButton
            connectorId="5ugr9q35ag"
            onLoad={handleLoad}
            onExitSuccess={handleExitSuccess}
            className="quiltt-Container-Class"
          >
            <Link />
            Link An Account
          </QuilttButton>
        </StyledSpan>
      </StyledDiv>
      {/* <StyledDiv>
          <StyledSpan>
            <QuilttButton
              connectorId="5ugr9q35ag"
              institution="Thrift"
              onLoad={handleLoad}
              onExitSuccess={handleExitSuccess}
              className="quiltt-Container-Class"
            >
              Connect TSP with <QuilttLogo />
            </QuilttButton>
          </StyledSpan>
        </StyledDiv>
        {intakeState.quilttUserId && (
          <StyledDiv>
            <StyledSpan>
              <Button
                sx={{
                  color: '#262726 !important',
                  fontWeight: '400',
                  textTransform: 'capitalize',
                }}
                className="quiltt-Container-Class"
                onClick={refreshQuiltt}
              >
                Refresh Account Balances <QuilttLogo />
              </Button>
            </StyledSpan>
          </StyledDiv>
        )}
        <StyledDiv onClick={getAssets}>
          <StyledSpan>
            <SoftTypography textAlign="center" color="dark" variant="body2">
              Refresh accounts
            </SoftTypography>
            &nbsp;
            <RefreshIcon />
          </StyledSpan>
        </StyledDiv> */}
    </>
  )
}
